

































import Component from "vue-class-component";
import StandardList from "front-component/components/List.vue";
import Orders from "@/components/miscellaneous/Orders.vue";
import Http from "front-component/Http";
import {Prop, Watch} from "vue-property-decorator";
import _ from "lodash";
import CatalogCode from "@/components/zero-waste/list/catalog/fields/CatalogCode.vue";
import CatalogName from "@/components/zero-waste/list/catalog/fields/CatalogName.vue";
import CatalogDate from "@/components/zero-waste/list/catalog/fields/CatalogDate.vue";
import CatalogEdit from "@/components/zero-waste/list/catalog/fields/CatalogEdit.vue";
import CatalogLink from "@/components/zero-waste/list/catalog/fields/CatalogLink.vue";
import CatalogType from "@/components/zero-waste/list/catalog/fields/CatalogType.vue";
import CatalogArmisValidation from "@/components/zero-waste/list/catalog/fields/CatalogArmisValidation.vue";
import EventBus from "front-component/EventBus";
import CatalogRepository from "@/repositories/zero-waste/CatalogRepository";
import {Catalog} from "@/components/forms/zero-waste/CatalogForm.vue";
import {Getter} from "vuex-class";

const components = {
    Orders,
    CatalogCode,
    CatalogName,
    CatalogDate,
    CatalogLink,
    CatalogEdit,
    CatalogType,
    CatalogArmisValidation,
};

@Component({ components })
export default class List extends StandardList {
    protected route: string = "get_operation";
    protected fields: string[] = [];
    public loading: boolean = false;
    public globalBudget: number = 0;

    @Getter("getCurrentOwnerUuid") public currentOwnerUuid!: string;

    @Prop( { default: 50}) public limitPerPage !: number;

    public mounted() {
        window.addEventListener("scroll", this.handleScroll);
        _.set(this.filters, "ownerUuid", this.currentOwnerUuid);
    }

    public created(): void {
        this.fields = Http.computeStandardFields(components, "catalog");
    }

    public beforeDestroy(): void {
        window.removeEventListener("scroll", this.handleScroll);
    }

    protected link(): string {
        return CatalogRepository.getSearchUrl();
    }

    @Watch("limitPerPage") public loadExport() {
        this.page = 1;
        this.hasNextPage = true;
        this.elements = [];
        this.loadUsingApi();
    }

    private launchEdition(catalog: Catalog) {
        this.$emit("show-catalog", catalog);
    }

    private handleScroll() {
        const fadeElement: any = document.querySelector(".selectedBadge");
        if (window.scrollY > 0) {
            if (fadeElement) {
                fadeElement.style.display = "none";
            }
        } else {
            if (fadeElement) {
                fadeElement.style.display = "block";
            }
        }
    }
}
